export enum MessageTemplateStatus {
  Active = 'active',
  InReview = 'in-review',
  Rejected = 'rejected',
  Draft = 'draft',
}
